import PropTypes from 'prop-types';
import React from 'react';

import './index.scss';

const SmallSelectButton = ({ selectButtonId, defaultCheckedButton, handleClick }) => {
  return (
    <div>
      <div className="select-buttons-small">
        <div>
          <button
            data-testid={`${selectButtonId}-yes`}
            className={
              defaultCheckedButton === true || defaultCheckedButton === 'true'
                ? 'select-button-small select-button-small--selected'
                : 'select-button-small'
            }
            value={true}
            onClick={handleClick}
            type="button"
          >
            Yes
          </button>
        </div>

        <div>
          <button
            data-testid={`${selectButtonId}-no`}
            className={
              defaultCheckedButton === false || defaultCheckedButton === 'false'
                ? 'select-button-small select-button-small--selected'
                : 'select-button-small'
            }
            value={false}
            onClick={handleClick}
            type="button"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

SmallSelectButton.propTypes = {
  selectButtonId: PropTypes.string.isRequired,
  defaultCheckedButton: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
};

SmallSelectButton.defaultProps = {
  defaultCheckedButton: null,
};

export default SmallSelectButton;
